<div
  class="scrollbar-dark flex flex-col bg-neutral-900 rounded-md overflow-y-auto items-stretch justify-start w-full h-full p-2"
>
  @for (log of reasoningLogs(); track log) {
    <div class="flex flex-row text-xs font-mono font-normal gap-2 items-stretch justify-between">
      <div class="flex flex-row gap-1 items-stretch justify-start">
        <div class="text-yellow-600">{{ log.agent | uppercase }}:</div>
        <div>
          <span class="font-bold">{{ log.operation }}</span> - {{ log.message }}
        </div>
      </div>
    </div>
  }
  @if (reasoningLogs().length === 0) {
    <div class="flex flex-row text-xs font-mono font-normal gap-2 items-stretch justify-start">
      <div class="text-neutral-400">No reasoning logs yet!</div>
    </div>
  }
</div>
